export default __webpack_public_path__ + "static/media/ic_gearbox.f4daf202.svg";